export const OK = 200
export const CREATED = 201
export const UNAUTHENTICATED = 401
export const UNPROCESSABLE_ENTITY = 422
export const INTERNAL_SERVER_ERROR = 500